import type { SystemUser, StaffRole, StaffRoleType } from '../../../types';

/**
 * Filters system users to those holding a given staff role, sorted by name. The
 * currently-assigned person (`keepId`) is always kept so an existing assignment is never
 * dropped from the list. When role data is unavailable (empty map) everyone is returned
 * unfiltered — better to show too many than to hide valid choices while roles load.
 */
export function filterUsersByRole(
  users: SystemUser[],
  roleMap: Map<string, StaffRole>,
  role: StaffRoleType,
  keepId: string,
): SystemUser[] {
  const sorted = [...users].sort((a, b) => a.fullName.localeCompare(b.fullName));
  if (roleMap.size === 0) return sorted;
  return sorted.filter(u =>
    roleMap.get(u.systemUserId)?.roles.includes(role) || u.systemUserId === keepId
  );
}
